import React from "react";

const LostPasswordComp = props => (
  <div>
    {props.isLostPassword ? (
      <form onSubmit={e => props.submit(e, "lostPassword")}>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="Email address"
            autoComplete="losts-email"
          />
          {props.chk_errors("email")}
        </div>
        <div>
          <button>Verify Email</button>
        </div>
      </form>
    ) : (
      <form onSubmit={e => props.submit(e, "updatePassword")}>
        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            name="password"
            placeholder="Password"
            autoComplete="losts-password"
          />
          {props.chk_errors("password")}
        </div>

        <div className="form-group">
          <label>Confirm Password</label>
          <input
            type="password"
            name="confirm_password"
            placeholder="Confirm Password"
            autoComplete="losts-confirm-password"
          />
          {props.chk_errors("confirm_password")}
        </div>

        <div>
          <button>Change Password</button>
        </div>
      </form>
    )}
    <hr />

    <div>
      Don’t have an account?{" "}
      <b className="signup" onClick={() => props.page("signup")}>
        Sign up
      </b>
    </div>
  </div>
);

export default LostPasswordComp;
